export const state = {
  projectTypeOfPur: 1,
  purchaseType: '',
  purchaseProcessList: '',
  goodsType: 2
};
